module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel4-en-GB@2x-add8987ae32b7d8fff7d83fb16350f44.png";